module.exports = __webpack_public_path__ + "img/pos_s1_icon3.cc333567.png";